import React from 'react';

const BackgroundTimeline = ({ children, latestHour }) => {
  let hours = [];
  const hvar_pct = 100.0 / (latestHour-7.0);
  for (var i = 7; i < latestHour + 1; i++) {
    hours.push(
      <div key={`hour-${i}`} className="eventsBackgroundHour" style={{height: hvar_pct+'%'}} />
    );
  }

  return (
    <div className="eventsBackgroundContainer">
      <div className="eventsBackground">{hours}</div>
      {children}
    </div>
  );
};

export default BackgroundTimeline;



// WEBPACK FOOTER //
// ./src/components/common/Calendar/BackgroundTimeline.js